import React, { createContext, PropsWithChildren, ReactElement } from 'react';

import { GlobalLanguage } from './messages';

export const LanguageContext = createContext<GlobalLanguage>('ko');

export function LanguageProvider({
  value,
  children,
}: PropsWithChildren<{ value?: GlobalLanguage }>): ReactElement {
  return (
    <LanguageContext.Provider value={value ?? 'ko'}>
      { children }
    </LanguageContext.Provider>
  );
}
